// Sales labels and channels — only Mostrador and Internet

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b' };

export const CHANNEL_COLORS = {
  store: C.mango,
  online: C.turquesa,
  // Legacy mappings (in case old data exists)
  redes: C.turquesa,
  whatsapp: C.turquesa,
  web: C.turquesa,
  local: C.mango,
  referido: C.mango,
  otro: '#999',
};

const STORE_LABELS = {
  productos: '🏪 Mostrador',
  rentas: '🏪 Presencial',
  boletos: '🏪 Punto de venta',
  servicios: '🏪 Presencial',
};

export function getChannelLabel(channel, salesType) {
  if (channel === 'store') return STORE_LABELS[salesType] || '🏪 Mostrador';
  if (channel === 'online') return '📱 Internet';
  if (['redes','whatsapp','web'].includes(channel)) return '📱 Internet';
  if (['local','referido'].includes(channel)) return STORE_LABELS[salesType] || '🏪 Mostrador';
  return '✨ Otro';
}

export const CHANNEL_LABELS = {
  store: '🏪 Mostrador',
  online: '📱 Internet',
  redes: '📱 Internet',
  whatsapp: '📱 Internet',
  web: '📱 Internet',
  local: '🏪 Mostrador',
  referido: '🏪 Mostrador',
  otro: '✨ Otro',
};

const BASE_CHANNELS = ['store', 'online'];

export function getSalesConfig(salesType) {
  switch (salesType) {
    case 'boletos':
      return {
        productLabel: '¿Qué evento?',
        productPlaceholder: 'Ej: Carrera 5K, Concierto...',
        unitLabel: 'Boletos vendidos',
        channels: BASE_CHANNELS,
        showNewCustomer: true,
      };
    case 'rentas':
      return {
        productLabel: '¿Qué se rentó?',
        productPlaceholder: 'Ej: Cabaña grande, Salón principal...',
        unitLabel: 'Rentas',
        channels: BASE_CHANNELS,
        showNewCustomer: false,
      };
    case 'servicios':
      return {
        productLabel: '¿Qué servicio diste?',
        productPlaceholder: 'Ej: Consulta, Sesión de fotos...',
        unitLabel: 'Servicios',
        channels: BASE_CHANNELS,
        showNewCustomer: false,
      };
    case 'productos':
    default:
      return {
        productLabel: '¿Qué vendiste?',
        productPlaceholder: 'Ej: Cartera, Bolsa, Pastel...',
        unitLabel: 'Ventas',
        channels: BASE_CHANNELS,
        showNewCustomer: false,
      };
  }
}
